import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import api from "../../config.json";
import axios from '../../httpServices/httpService';
import swal from "sweetalert";
import valid from '../../utill/validation';
import joi from 'joi';
import Loading from "../../utill/LoadingComponent";
import MultiSelect from "../../Common/multiselect";
import { useLocation, useHistory } from 'react-router-dom'
import authService from "../../httpServices/authService";

const User = (props) => {
  const location = useLocation()
  const history = useHistory()
  const [user, setUser] = useState({ userType: 'user' });
  const [oldObj, setOldObj] = useState({});
  const [modelState, setModelState] = useState(false);
  const [selectedPlant, setSelectedPlant] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [errors, setErrors] = useState({});
  const [querySuccess, setQuerySuccess] = useState(false);
  const [userGroup, setUserGroup] = useState([]);
  const [roles, setUserRoles] = useState([])
  const currentUser = authService.getCurrentUser() || {};
  const buttonRef = useRef();

  const schema = {
    name: joi.string().required().label('User Name'),
    email: joi.string().email().required().label('Email'),
    userType: joi.string(),
    UserGroup: joi.string().required().label('User Group'),
    // UserRole: joi.string().required().label('User Role'),
  };



  useEffect(() => {
    // getAllRoles()
    // axios.get(api.api + 'usergroup')
    //   .then((result) => {
    //     setUserGroup(result.data);
    //   })
    //   .catch((err) => {
    //     toast.error(`${err}`, {
    //       position: 'bottom-right',
    //       autoClose: 2000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       style: {
    //         background: 'red',
    //         color: 'white',
    //       },
    //     });
    //   });

    if (location.state && location.state.action === "update") {
      const userObj = { ...location.state.data };
      setUser(userObj);
      setOldObj(userObj);
    }

    if (location.state && location.state.action === "add") {
      setUser({ userType: "user" });
    }
  }, [location.state, props.user]);

  // const getAllRoles = () => {
  //   axios.get(api.api + "userrole")
  //     .then((result) => {
  //       setUserRoles(result.data.map(x => { return { label: x.UserRole, value: x.UserRole } }))
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  // }

  const handleUserSubmit = (data) => {
    if (location.state && location.state.action === 'add') {
      data.UserGroup = 'default';
      const validationErrors = valid.validate(data, schema);
      setErrors(validationErrors || {});
      if (validationErrors) return;
      data.userType = 'user';
      setQuerySuccess(true);
      axios.post(api.api + 'user', data)
        .then((result) => {
          if (result.status === 200) {
            setQuerySuccess(false);
            history.push('/setting/user/list');
            swal({
              title: "INSERT",
              text: "User Created Successfully!",
              icon: "success"
            });
          } else {
            setQuerySuccess(false);
            swal('Data Not Saved');
          }
        })
        .catch((err) => {
          setQuerySuccess(false);
          swal(`${err.response.data.message}`);
        });
    }

    if (location.state && location.state.action === 'update') {

      setQuerySuccess(true);
      axios.patch(api.api + 'user/' + oldObj._id, { new: data, old: oldObj })
        .then((result) => {
          if (result.data.n === 1 && result.data.nModified === 1 && result.data.ok === 1) {
            setQuerySuccess(false);
            history.push('/setting/user/list');
            swal('User Updated Successfully');
          } else {
            setQuerySuccess(false);
          }
        })
        .catch((err) => {
          setQuerySuccess(false);
          swal(`${err.response.data.message}`);
        });
    }
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;
    const newUser = { ...user };
    const newErrors = { ...errors };
    const errorMessage = valid.validateProperty(e.currentTarget, schema);

    if (errorMessage) newErrors[name] = errorMessage;
    else delete newErrors[name];

    newUser[name] = value;
    setUser(newUser);
    setErrors(newErrors);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {querySuccess ? <Loading /> : ''}

      <div className="border">
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group text-center">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Name"
                name="name"
                onChange={handleOnChange}
                value={user.name || ""}
              />
              {errors.name && <div className="alert small alert-danger">{errors.name}</div>}
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group text-center">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="email@example.com"
                name="email"
                onChange={handleOnChange}
                value={user.email || ""}
              />
              {errors.email && <div className="alert small alert-danger">{errors.email}</div>}
            </div>
          </div>

          {/* <div className="col-sm-4">
            <div className="form-group text-center">
              <label>WhatsApp No</label>
              <input
                type="text"
                className="form-control"
                placeholder="WhatsApp Number"
                name="WhatsAppNumber"
                onChange={handleOnChange}
                value={user.WhatsAppNumber || ""}
                maxLength={10}
                onKeyPress={(e) => {
                  const inputChar = String.fromCharCode(e.charCode);
                  if (!/^[0-9]+$/.test(inputChar)) {
                    e.preventDefault();
                  }
                }}
              />
              {errors.WhatsAppNumber && <div className="alert small alert-danger">{errors.WhatsAppNumber}</div>}
            </div>
          </div> */}

          <div className="col-sm-4">
            <div className="form-group text-center">
              <label>User Type</label>
              <select
                className="custom-select form-control"
                name="userType"
                onChange={handleOnChange}
                value={user.userType || 'user'}
              >
                <option>--Select UserType--</option>
                <option value="user">user</option>
                {currentUser.userType === 'admin' && <option value="admin">admin</option>}
                <option value="screen">screen</option>
              </select>
              {errors.userType && <div className="alert small alert-danger">{errors.userType}</div>}
            </div>
          </div>
          {/* <div className="col-sm-4">
            <div className="form-group text-center">
              <label>User Role</label>
              <select
                className="custom-select form-control"
                name="UserRole"
                onChange={handleOnChange}
                value={user.UserRole || ''}
              >
                <option>--Select User Role--</option>
                {roles.map(x=>{
                  return <option value={x.value}>{x.label}</option>
                })}
              </select>
              {errors.UserRole && <div className="alert small alert-danger">{errors.UserRole}</div>}
            </div>
          </div> */}

          {/* <div className="col-sm-4">
            <div className="form-group text-center">
              <label>User Group</label>
              <MultiSelect
                name="UserGroup"
                selected={user.UserGroup}
                handleOnChange={handleOnChange}
                masterName="UserGroup"
                objLevel={1}
                all={userGroup}
              />
              {errors.UserGroup && <div className="alert small alert-danger">{errors.UserGroup}</div>}
            </div>
          </div> */}
        </div>

        <div className="text-center">
          <button
            className="btn btn-primary"
            onClick={() => handleUserSubmit(user)}
          >
            Submit
          </button>
        </div>
        <input
          ref={buttonRef}
          type="reset"
          style={{ visibility: "hidden" }}
        />
      </div>
    </React.Fragment>
  );
};

export default User;
